'use strict';

var Validator = require('validatorjs');
var Mapper = require('./Mapper.js');
var Formatter = require('./Formatter.js');
var DateTime = require('./DateTime.js');
var _ = require('lodash');
var ApplicationConstants = require('../constants/ApplicationConstants');
var ContentService = require('../services/ContentService');
var INLINE = 'inline';
var SUMMARY = 'summary';
var isFirstLoad = true;
const CountryAustralia = 'AU';

//Custom validation rules 
function _validateAbn(str) {
    if (str.length !== 11){
        return false;
    }
    str = str.toString();
    if (str[0] === '0'){
        return false;
    }
    var i, returnVal;
    var total = 0;
    //weighting factors
    var values = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    var viewValue = str;
    total = (viewValue[0] - 1) * values[0];

    for (i = 1; i < 11; ++i) {
        total += viewValue[i] * values[i];
    }

    returnVal = (total % 89 == 0);
    return returnVal;
}

function _validateAcn(str) {
    if (str.length !== 9){
        return false;
    }
    str = str.toString();
    var i;
    var returnVal = false;
    var total = 0;
    //weighting factors
    var values = [8, 7, 6, 5, 4, 3, 2, 1];
    var viewValue = str;

    for (i = 0; i < values.length; ++i) {
        total += viewValue[i] * values[i];
    }
    var sub = (10 - (total % 10)) % 10;
    //Compare remainder value to the actual checkdigit value digit [always the last value]
    if (sub == viewValue[8]) {
        returnVal = true;
    }

    return returnVal;
}

function _validateMinimumAge(val) {
    var age = DateTime.getAge(new Date(), val);
    if (age >= 0 && age < 18) {
        return false;
    }
    return true;
}

function _exceedMaxLength(val, requirement) {
    var inputLength = val.toString().length;
    return inputLength <= requirement;
}

function _mustBeExactLength(val, requirement) {
    var inputLength = val.toString().length;
    return inputLength == requirement;
}

function _mobileNumberOrEmailRequired(val, requirement) {
    var str1 = String(val).replace(/\s/g, '');
    var str2 = String(requirement).replace(/\s/g, '');
    var val1 = (val == 'undefined' || val == undefined || val == null || val=='null' || str1.length ==0);
    var val2 = (requirement == 'undefined' || requirement == undefined || requirement == null || requirement=='null' || str2.length ==0);
    return (val1 && val2) ? false : true ; 
}

function _validateTfn(tfn) {
    var weights = [], split = [], total = 0, valid = false;

    if (tfn) {
        if (!isNumber(tfn)) {
            return valid;
        }
        if (tfn.length > 0 && tfn.length < 8) {
            return valid;
        }
        if (tfn.length === 8) {
            tfn = 0 + tfn;
        }
        split = tfn.split('');
        if (split[0] === '0') {
            weights = [0, 10, 7, 8, 4, 6, 3, 5, 1];
        }
        else {
            weights = [10, 7, 8, 4, 6, 3, 5, 2, 1];
        }
        for (var i = 0; i < split.length; i++) {
            total = total + (split[i] * weights[i]);
        }

        if (total % 11 === 0) {
            valid = true;
        }
        else {
            valid = false;
        }
    }
    return valid;
}

function _dateValid(val){
    var dateJson = DateTime.dateStringToJson(val);
    if (dateJson.year < 1900) {
        return false;
    }
    if (DateTime.dateStringToDate(val) > new Date()) {
        return false;
    }
    if (DateTime.isDateToday(new Date(), val)) {
        return false;
    }
    return true;
}

function _landLineNumber(val){
    if (['02', '03', '07', '08'].indexOf(val.substr(0, 2)) === -1) {
        return false;
    }

    return true;
}

function _futureDateOnly(val) {
    if (DateTime.dateStringToDate(val) > new Date()) {
        return true;
    }
    return false;
}

function _todayOrFutureDateOnly(val) {
    var validDate = new Date();
    validDate.setHours(0,0,0,0);
    if (DateTime.dateStringToDate(val) >= validDate) {
        return true;
    }
    return false;
}

function _valueMustBeGreaterThanRequirement(val, requirement) {
    return Mapper.toCurrency(val) >= Mapper.toCurrency(requirement);
}

function _poBoxValidation(val){
    var pattern = /((P\.?O\.?(B\.?)?(\s+Box)?)|(Post\s+Office(\s+Box)?)|(reply\s+paid))\s*#?[0-9]+/gi;

    return !pattern.test(val);
}

function _validateSofSow(val) {
    const result = val && val.split(',')
    return result.length <= 5
}

function _abnAcnValidation(val){
    return _mustBeExactLength(val, 11) || _mustBeExactLength(val, 9);
}

Validator.register('tfn', function (tfn /*, requirement, attribute*/) {
    return _validateTfn(tfn);
});

Validator.register('tfnPension', function (tfn /*, requirement, attribute*/) {
    return _validateTfn(tfn);
});

Validator.register('tfnWithConsent', function (tfn /*, requirement, attribute*/) {
    return _validateTfn(tfn);
});

Validator.register('abnAcn', function (val /*, requirement, attribute*/) {
    /*
    Note :  check sum logic of ACN, ARBN, and ARSN are the same 
    reference: http://asic.gov.au/for-business/starting-a-company/how-to-start-a-company/australian-company-numbers/australian-company-number-digit-check/
    */
    return _validateAbn(val) || _validateAcn(val);
});

Validator.register('abn', function (val /*, requirement, attribute*/) {
    return _validateAbn(val);
});

Validator.register('mobileNumber', function (val) {
    return isPhoneNumber(val) && isMobileNumber(val);
});

Validator.register('landLineNumber', function (val) {
   return isPhoneNumber(val) && _landLineNumber(val); 
});

Validator.register('workPhoneNumber', function (val) {
    return isPhoneNumber(val) && (isMobileNumber(val) || _landLineNumber(val)); 
});

Validator.register('maxLength', function (val, requirement) {
    return _exceedMaxLength(val, requirement);
});

Validator.register('digitMaxLength', function (val, requirement) {
    return _exceedMaxLength(val, requirement);
});

Validator.register('tin', function (val) {
    return val.length == 0 ||
        (val.length > 5 && val.length < 31) && !/[\!\@\#\$\*\(\)\"\|\,]/.test(val);
});

Validator.register('firstCharIsNotAlpha', function (val) {
    return /[A-Za-z]/.test(val.charAt(0));
});

Validator.register('name', function (val) {
    return /^[A-Za-z\-']+$/.test(val);
});

Validator.register('givenName', function (val) {
    return givenName(val);
});

Validator.register('title', function (val) {
    return title(val);
});

Validator.register('dateInvalidFormat', function (val) {
    return /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(val);
});

Validator.register('dateIsInvalid', function (val) {
    return _dateValid(val) && DateTime.isDateExist(val);
});

Validator.register('pensionDobMinimumAge', function (val) {
    return _validateMinimumAge(val);
});

Validator.register('investmentDobMinimumAge', function (val) {
    return _validateMinimumAge(val);
});

Validator.register('comminsureDobMinimumAge', function (val) {
    return _validateMinimumAge(val);
});

Validator.register('challengerDobMinimumAge', function (val) {
    return _validateMinimumAge(val);
});

Validator.register('addressIsPoBox', function (val) {
    return _poBoxValidation(val);
});

Validator.register('businessAddressIsPoBox', function (val) {
    return _poBoxValidation(val);
});

Validator.register('email', function (val) {
    var pattern = /^(?!\.){1}([\w\-\.]+)@((\[([0-9]{1,3}\.){3}[0-9]{1,3}\])|(([\w\-]+\.)+)([a-zA-Z]{2,4}))$/;

    return pattern.test(val);
});

Validator.register('isDigit', function (val, requirement) {
    return val.length >= requirement && isNumber(val);
});

Validator.register('amountMustBeLessThanBalance', function (val, requirement) {
    return Mapper.toCurrency(val) <= Mapper.toCurrency(requirement);
});

Validator.register('amountMustNotBeEqualToBalance', function (val, requirement) {
    return Mapper.toCurrency(val) !== Mapper.toCurrency(requirement);
});

Validator.register('amountMustBeGreaterThanMaintaining', function (val, requirement) {
    return _valueMustBeGreaterThanRequirement(val, requirement);
});


Validator.register('alphaNum', function (val) {
    return (/^[a-zA-Z0-9]+$/).test(val);
});

Validator.register('currency', function (val) {
    return currencyValidation(val);
});

Validator.register('numSpace', function (val) {
    return (/^[0-9 ]+$/).test(val);
});

Validator.register('exactLength', function (val, requirement) {
    return _mustBeExactLength(val, requirement);
});

Validator.register('digitExactLength', function (val, requirement) {
    return _mustBeExactLength(val, requirement);
});

Validator.register('mobileNumberOrEmailRequired', function (val, requirement) {
    return _mobileNumberOrEmailRequired(val, requirement);
});

Validator.register('tfnExactLength', function (val) {
    return _mustBeExactLength(val, 8) || _mustBeExactLength(val, 9);
});

Validator.register('abnArbnArsnExactLength', function (val) {
    return _abnAcnValidation(val);
});

Validator.register('abnAcnExactLength', function (val) {
    return _abnAcnValidation(val);
});

Validator.register('abnAcnArsnExactLength', function (val) {
    return _abnAcnValidation(val);
});

Validator.register('abnArbnExactLength', function (val) {
    return _abnAcnValidation(val);
});

Validator.register('numeric2', function (val) {
    return (/^[0-9]+$/).test(val);
});

Validator.register('alphaNumWithSpaces', function (val) {
    return (/^[a-zA-Z0-9\ ]+$/).test(val);
});

Validator.register('nameWithNumSpaces', function (val) {
    return /^[a-zA-Z0-9\-' ]+$/.test(val);
});


Validator.register('atLeastOneAlpha', function (val) {
    return (/[a-zA-Z]/).test(val);
});

Validator.register('amountMustNotBeZero', function (val) {
    return (val === '0.00') ? false : true;
});

Validator.register('balanceMustNotBeZero', function (val) {
    return (val === '0.00') ? false : true;
});

Validator.register('currencyMaxLength', function (val) {
    return isCurrencyMaxLength(val);
});

Validator.register('shouldBeFutureDate', function (val) {
    return _futureDateOnly(val) && DateTime.isDateExist(val);
});

Validator.register('shouldBeTodayOrFutureDate', function (val) {
    return _todayOrFutureDateOnly(val) && DateTime.isDateExist(val);
});

Validator.register('amountMustBeGreaterThanMinimum', function (val, requirement) {
    return _valueMustBeGreaterThanRequirement(val, requirement);
});

Validator.register('percentMaxLength', function (val) {
    return Mapper.toCurrency(val) > 100 ? false : true;
});

Validator.register('percentMaxLength15', function (val) {
    return isPercentMaxLength15(val);
});

Validator.register('amountPerMonthLessThan100', function (val) {
    return Mapper.toCurrency(val) < 100 ? false : true;
});

Validator.register('addressNotFound', function () {
    return false;
});

Validator.register('countryShouldBeAU', function(val){
    return val === CountryAustralia;
});

Validator.register('sofsowMaxOption', function (val) {
    return _validateSofSow(val);
});

function initialiseErrorMessagesForInline() {
    var messages = _.clone(ContentService.getContent().inlineErrorMessages);
    Validator.setMessages(INLINE, messages);
}

function initialiseErrorMessagesForErrorSummary() {
    var messages = _.clone(ContentService.getContent().summaryErrorMessages);
    Validator.setMessages(SUMMARY, messages);
}

function setMessages() {
    initialiseErrorMessagesForInline();
    initialiseErrorMessagesForErrorSummary();
}

function capitalize(str, isForErrorSummary) {
    if (!str) {
        return null;
    }
    var firstLetterIndex = isForErrorSummary ? 0 : 4;
    var startLetter = str.charAt(firstLetterIndex).toUpperCase();
    var capitalize = str.substr(0, firstLetterIndex) + startLetter + str.slice(firstLetterIndex + 1);
    return capitalize;
}

function  isNumber(val) {
    return /^[0-9]+$/.test(val);
}

function isPhoneNumber (val) {
    if ((!isNumber(val)) || (val.length > 0 && val.length < 10)) {
        return false;
    }
    return true;
}

function isMobileNumber (val) {
    if (['04', '05'].indexOf(val.substr(0, 2)) === -1) {
        return false;
    }

    return true;
}

function currencyValidation(val) {
    val = Formatter.removeCommas(val);

    if (val.toString().indexOf('$') > -1) {
        return false;
    }

    var regex = /(?=.)^\$?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?(\.[0-9]{1,2})?$/;
    return regex.test(val);
}

function isCurrencyMaxLength (val) {
    var paraseVal = Formatter.currencyFormatWithoutRounding(val);
    var currVal = Formatter.currencyUnformat(paraseVal);

    if (currVal.indexOf('e+') > 0 || currVal.indexOf('E+') > 0) {
        return false;
    }

    return (currVal.length > 12) ? false : true;
}

function isPercentMaxLength15 (val) {
    return parseInt(val, 10) === 0 || val > 15 ? false : true;    
}

function givenName(val) {
    return /^[A-Za-z\- ']+$/.test(val);
}

function title(val) {
    var id = parseInt(val, 10);
    // only valid IDs for title are 1 to 7 according to database table 'Title'
    return 1 <= id && id <= 7;
}

var Validators = {
    createValidator: function(data, rules, customAttributeNames, isForErrorSummary) {
        if (isFirstLoad) {
            setMessages();
            isFirstLoad = false;
        }

        //The current workaround is kind of clean, but having to validate twice -
        //one for inline and one for summary in order to get the different messages
        if (isForErrorSummary) {
            Validator.useLang(SUMMARY);
        } else {
            Validator.useLang(INLINE);
        }

        var validator = new Validator(data, rules);
        validator.setAttributeNames(customAttributeNames);
        validator.passes(); //execute

        return validator;
    },

    //ValidateField - it removes the old validation of the fieldId, before revalidating it again 
    validateField: function(data, rules, customAttributeNames, errorList, fieldId, componentId) {
        componentId = componentId || fieldId;
        this.clearErrorListForField(errorList, componentId);
        var validator = this.createValidator(data, rules, customAttributeNames);
        if (validator.fails() && errorList) {
            var message = capitalize(validator.errors.first(fieldId));
            errorList.push({ message: message, id: componentId, type: ApplicationConstants.messageTypes.error });
        }
        return validator;
    },

    validateAll: function(data, rules, customAttributeNames, id, sectionName, multipleSectionPrefix) {
        var errorList = [];
        var validator = this.createValidator(data, rules, customAttributeNames, sectionName);
        if (validator.fails()) {
            var prop = sectionName ? { clickable: sectionName } : { type: ApplicationConstants.messageTypes.error };
            var multipleSectionId = '';
            if (multipleSectionPrefix) {
                multipleSectionId = multipleSectionPrefix + ' - ';
            }
            for (var error in validator.errors.errors) {
                var message = multipleSectionId + capitalize(validator.errors.first(error), sectionName);
                errorList.push(_.assign({ message: message, id: (id) ? id.replace('{x}', error) : error }, prop));
            }
        }
        return errorList;
    },

    clearErrorListForField: function(errorList, fieldId) {
        if (errorList && errorList.length > 0) {
            _.remove(errorList, function(o) { return !o ? null : o.id === fieldId });
        }
    },

    isNumeric: function(value) {
        var num = !isNaN(value) ? value : '';
        return num;
    },

    isNumber: isNumber,

    isPhoneNumber: isPhoneNumber,

    isMobileNumber: isMobileNumber,

    currencyValidation: currencyValidation,

    isCurrencyMaxLength: isCurrencyMaxLength,

    isPercentMaxLength15: isPercentMaxLength15,

    givenName: givenName,

    title: title,

    //Validate the currency format
    //ex: 1,000.00 - true
    //ex: abc - false
    //ex: 12+e - false
    isCurrency: function (value) {
        return !isNaN(value.toString().replace(/[,.]/g, ''));
    },

    requiredValidation: function (val) {
        var str;

        if (val == undefined) {
            return false;
        }

        str = String(val).replace(/\s/g, '');
        return str.length > 0 ? true : false;
    }
}

module.exports = Validators;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/Validators.js